import * as types from "./types";
import {
  getAllocationListAxios,
  postAllocationAxios,
  putAllocationAxios,
  deleteAllocationAxios,
  getPayrollListAxios,
  postPayrollAxios,
  getPayrollExportAxios,
  postImportAllocationAxios, getEmployeePayrollAxios
} from "./services";

export async function getAllocationListAction({ commit }) {
  commit(types.LOADING_ALLOCATION, true);
  try {
    const { data } = await getAllocationListAxios();
    commit(types.GET_ALLOCATION_LIST, data.result.data);
  }
  catch (e) {

    throw e;
  }
  finally {
    commit(types.LOADING_ALLOCATION, false);
  }

}

export async function importAllocationAction({ commit }, payload) {
  commit(types.LOADING_ALLOCATION, true);
  try {
    const { data } = await postImportAllocationAxios(payload);
    (payload);
    commit(types.IMPORT_ALLOCATION, payload);
    return data;
  }
  catch (e) {
    throw e;
  }
  finally {
    commit(types.LOADING_ALLOCATION, false);
  }
}

export async function addAllocationAction({ commit }, payload) {
  commit(types.LOADING_ALLOCATION, true);
  try {
    const { data } = await postAllocationAxios(payload);
    payload.id = data.result.id;
    commit(types.ADD_ALLOCATION, payload);
  } catch (e) {

    throw e;
  } finally {
    commit(types.LOADING_ALLOCATION, false);
  }
}

export async function updateAllocationAction({ commit }, payload) {
  commit(types.LOADING_ALLOCATION, true);
  try {
    await putAllocationAxios(payload);
    commit(types.UPDATE_ALLOCATION, payload);
  } catch (e) {

    throw e;
  } finally {
    commit(types.LOADING_ALLOCATION, false);
  }
}

export async function removeAllocationAction({ commit }, id) {
  commit(types.LOADING_ALLOCATION, true);
  try {
    await deleteAllocationAxios(id);
    commit(types.REMOVE_ALLOCATION, id);
  }
  catch (e) {

    throw e;
  }
  finally {
    commit(types.LOADING_ALLOCATION, false);
  }
}

export async function getPayrollListAction({ commit }, { allocationDate, employeeId }) {
  commit(types.LOADING_ALLOCATION, true);
  try {
    commit(types.GET_PAYROLL_LIST, []);
    const { data } = await getPayrollListAxios(allocationDate, employeeId);
    commit(types.GET_PAYROLL_LIST, data.result);
    return data.result;
  }
  catch (e) {

    throw e;
  }
  finally {
    commit(types.LOADING_ALLOCATION, false);
  }
}

export async function getEmployeePayrollAction({ commit }, { employeeId }) {
  commit(types.LOADING_ALLOCATION, true);
  try {
    commit(types.GET_EMPLOYEE_PAYROLL, []);
    const { data } = await getEmployeePayrollAxios(employeeId);
    commit(types.GET_EMPLOYEE_PAYROLL, data.result);
    return data.result;
  }
  catch (e) {

    throw e;
  }
  finally {
    commit(types.LOADING_ALLOCATION, false);
  }
}

export async function postPayrollAction({ commit }, allocationDate) {
  commit(types.LOADING_ALLOCATION, true);
  try {
    const { data } = await postPayrollAxios(allocationDate);
    commit(types.ADD_PAYROLL, data.result.data);
  }
  catch (e) {

    throw e;
  }
  finally {
    commit(types.LOADING_ALLOCATION, false);
  }
}

export async function exportPayrollAction({ commit }, allocationDate) {
  try {
    const response = await getPayrollExportAxios(allocationDate);

    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `payroll_${allocationDate}.csv`);
    document.body.appendChild(link);
    link.click();

  } catch (error) {
    console.error("Error exporting payroll:", error);
  }
}